export default theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.border}`,
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    height: '55px',
    zIndex: theme.zIndex.appBar
  },
  toolbar: {
    minHeight: 'auto',
    width: '100%',
    position: 'relative'
  },
  title: {
    marginLeft: theme.spacing()
  },
  menuButton: {
    marginLeft: '-4px'
  },
  notificationsButton: {
    // marginLeft: 'auto'
  },
  helpButton: {
    marginLeft: 'auto'
  },
  signOutButton: {
    marginLeft: theme.spacing()
  }
});
